import Vue from 'vue'
import Vuex from 'vuex'
import * as fb from '../firebase'
import router from '../router/index'
import VueVirtualScoller from 'vue-virtual-scroller'

Vue.use(Vuex)
Vue.use(VueVirtualScoller)



const store = new Vuex.Store({
  state: {
    userProfile: {},
    userRole: {},
    userId: '',
    sites: [],
    liveSite: {}
  },
  mutations: {
    setUserProfile(state, val) {
      state.userProfile = val
    },
    setUserId(state, val) {
      state.userId = val
    },
    setUserRole(state, val) {
      state.userRole = val
    },
    setPerformingRequest(state, val) {
      state.performingRequest = val
    },
    setPosts(state, val) {
      state.posts = val
    },
    setSites(state, val){
      state.sites.push(val)
    },
    setLiveSite(state, val){
      state.liveSite = val
    },
    removeSites(state, val){
      state.sites = []
    }


  },
  actions: {
    async login({ dispatch }, form) {
      // sign user in
      const { user } = await fb.auth.signInWithEmailAndPassword(form.email, form.password)
      console.log('logging in')
      // fetch user profile and set in state
      dispatch('fetchUserProfile', user)
    },
    async signup({ dispatch }, form) {
      // sign user up
      await fb.auth.signInWithEmailLink(form.email, form.apiKey).then((result) => {
        console.log(result)
        console.log(result.user.uid)
        
        dispatch('fetchUserProfile', result.user)

      })
      .catch((error) => {
        console.log(error)
        console.log(error.code)
        // Some error occurred, you can inspect the code: error.code
        // Common errors could be invalid email and invalid or expired OTPs.
      });

      console.log('signed in?')

      // // create user object in userCollections
      // await fb.usersCollection.doc(user.uid).set({
      //   name: form.name,
      //   title: form.title
      // })

      // console.log('added')

      // fetch user profile and set in state
      //dispatch('fetchUserProfile', user)

    },
    async fetchUserProfile({ commit }, user) {
      // fetch user profile
      const userProfile = await fb.usersCollection.doc(user.uid).get()

      //fetch user role
      //const userRole = await fb.userPermissions.doc(user.uid).get()
      
      // set user profile in state
      commit('setUserProfile', userProfile.data())

      // set user role in state, - check if 2x commits is acceptable?
      //commit('setUserRole', userRole.data())

      commit('setUserId', user.uid)

      //alert(userProfile.data().sites)

      let siteNum = 0

      userProfile.data().sites.forEach(element => fb.cameraCollection.doc(element).get()
      .then(value => {

        

        let name = value.data().site
        let id = element

        let siteObject = {'name':name, 'id':id}

        if(siteNum == 0){
          commit('setLiveSite', id)
          siteNum = -1
        }

        commit('setSites', siteObject)

      }))


      if (userProfile.data().profile_complete == false){
        router.push('/complete_profile')
      }


      


      // change route to dashboard
      else if (router.currentRoute.path === '/login' || router.currentRoute.path === '/signup') {
        router.push('/')
      }

    },


    async setLiveSite({ commit }, id){
      commit('setLiveSite', id)
    },
    
    async logout({ commit }) {
      // log user out
      await fb.auth.signOut()

      // clear user data from state
      commit('setUserProfile', {})

      commit('setUserId', '')

      commit('setLiveSite', '')

      commit('removeSites', [])

      // redirect to login view
      router.push('/login')
    },
    
    async updateProfile({ dispatch }, user) {
      const userId = fb.auth.currentUser.uid
      // update user object
      const userRef = await fb.usersCollection.doc(userId).update({
        name: user.name,
        title: user.title
      })

      dispatch('fetchUserProfile', { uid: userId })

      // update all posts by user
      const postDocs = await fb.postsCollection.where('userId', '==', userId).get()
      postDocs.forEach(doc => {
        fb.postsCollection.doc(doc.id).update({
          userName: user.name
        })
      })

      // update all comments by user
      const commentDocs = await fb.commentsCollection.where('userId', '==', userId).get()
      commentDocs.forEach(doc => {
        fb.commentsCollection.doc(doc.id).update({
          userName: user.name
        })
      })
    },
    
    async setPassword({ dispatch }, password){

      fb.auth.currentUser.updatePassword(password.password).then(() => {

        console.log('password set!')
        dispatch('profileComplete')

      }, (error) => {
        console.log('error setting password')
      })

    },

    async profileComplete({ dispatch }) {
      const userId = fb.auth.currentUser.uid
      // update user object
      const userRef = await fb.usersCollection.doc(userId).update({
        profile_complete : true
      })
      router.push('/')
    },

    

  }
})

export default store
